import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MESSAGE_ERROR, MESSAGE_INFO, MESSAGE_TYPE, MESSAGE_WARNING } from '../../constants/message';

interface Message {
    id: number;
    text: string;
}

interface MessageState {
    lastMessageId: number;
    errorMessages: Message[];
    infoMessages: Message[];
    warningMessages: Message[];
}

type NewMessageTuple = [MESSAGE_TYPE, string];

const initialState: MessageState = {
    lastMessageId: 0,
    errorMessages: [],
    infoMessages: [],
    warningMessages: [],
};

const messageSlice = createSlice({
    name: 'message',
    initialState,
    reducers: {
        addMessages: (state, action: PayloadAction<NewMessageTuple[]>) => {
            action.payload.forEach(([type, text]) => {
                const newId = state.lastMessageId + 1;
                const message: Message = { id: newId, text };

                switch (type) {
                    case MESSAGE_ERROR:
                        state.errorMessages.push(message);
                        break;
                    case MESSAGE_INFO:
                        state.infoMessages.push(message);
                        break;
                    case MESSAGE_WARNING:
                        state.warningMessages.push(message);
                        break;
                    default:
                        state.infoMessages.push(message);
                        break;
                }

                state.lastMessageId = newId;
            });
        },
        clearMessages: (state, action: PayloadAction<number[]>) => {
            const idsToClear = new Set(action.payload);

            state.errorMessages = state.errorMessages.filter((msg) => !idsToClear.has(msg.id));
            state.infoMessages = state.infoMessages.filter((msg) => !idsToClear.has(msg.id));
            state.warningMessages = state.warningMessages.filter((msg) => !idsToClear.has(msg.id));
        },
    },
});

export const { addMessages, clearMessages } = messageSlice.actions;
export default messageSlice.reducer;
